"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiomCircuitRunner = void 0;
const ethers_1 = require("ethers");
const utils_1 = require("./utils");
const constants_1 = require("./constants");
const utils_2 = require("@axiom-crypto/halo2-lib-js/shared/utils");
const halo2_lib_js_1 = require("@axiom-crypto/halo2-lib-js");
const autoParseDataInputs = (inputs) => {
    let parsedInputs = JSON.parse(inputs);
    let parsedInputKeys = Object.keys(parsedInputs);
    for (let key of parsedInputKeys) {
        let val = parsedInputs[key];
        if (Array.isArray(val)) {
            const newval = [];
            let isCircuitValue256 = null;
            for (let nestedKey of val) {
                if (String(nestedKey).length == 66) {
                    if (isCircuitValue256 === false)
                        throw new Error("All array elements must be of the same type");
                    isCircuitValue256 = true;
                    newval.push((0, utils_1.getCircuitValue256Witness)(nestedKey));
                }
                else {
                    if (isCircuitValue256 === true)
                        throw new Error("All array elements must be of the same type");
                    isCircuitValue256 = false;
                    newval.push((0, utils_1.getCircuitValueWitness)(nestedKey));
                }
            }
            parsedInputs[key] = newval;
        }
        else if (String(val).length == 66) {
            parsedInputs[key] = (0, utils_1.getCircuitValue256Witness)(val);
        }
        else {
            parsedInputs[key] = (0, utils_1.getCircuitValueWitness)(val);
        }
    }
    return parsedInputs;
};
const parseDataInputsFromSchema = (inputs, inputSchema) => {
    let parsedInputs = JSON.parse(inputs);
    let parsedInputKeys = Object.keys(parsedInputs);
    let parsedSchema = JSON.parse(inputSchema);
    for (let key of parsedInputKeys) {
        const type = parsedSchema[key];
        const val = parsedInputs[key];
        if (type === "CircuitValue") {
            parsedInputs[key] = (0, utils_1.getCircuitValueWitness)(val);
        }
        else if (type === "CircuitValue256") {
            parsedInputs[key] = (0, utils_1.getCircuitValue256Witness)(val);
        }
        else if (type === "CircuitValue[]") {
            const newval = [];
            for (let nestedKey of val) {
                newval.push((0, utils_1.getCircuitValueWitness)(nestedKey));
            }
            parsedInputs[key] = newval;
        }
        else if (type === "CircuitValue256[]") {
            const newval = [];
            for (let nestedKey of val) {
                newval.push((0, utils_1.getCircuitValue256Witness)(nestedKey));
            }
            parsedInputs[key] = newval;
        }
        else {
            throw new Error(`Invalid type ${type}`);
        }
    }
    return parsedInputs;
};
const parseDataInputs = (inputs, inputSchema) => {
    if (inputSchema !== undefined) {
        return parseDataInputsFromSchema(inputs, inputSchema);
    }
    else {
        return autoParseDataInputs(inputs);
    }
};
const padInstances = (capacity) => {
    const halo2Lib = globalThis.axiom.halo2lib;
    const halo2Wasm = globalThis.axiom.halo2wasm;
    let userInstances = [...halo2Wasm.getInstances(0)];
    const numUserInstances = userInstances.length;
    const dataInstances = [...halo2Wasm.getInstances(1)];
    const numDataInstances = dataInstances.length;
    const NUM_USER_INSTANCES = capacity.maxOutputs * constants_1.USER_OUTPUT_FE;
    const NUM_DATA_INSTANCES = capacity.maxSubqueries * constants_1.SUBQUERY_FE;
    for (let i = numUserInstances; i < NUM_USER_INSTANCES; i++) {
        let witness = halo2Lib.constant("0");
        userInstances.push(witness);
    }
    for (let i = numDataInstances; i < NUM_DATA_INSTANCES; i++) {
        let witness = halo2Lib.constant("0");
        dataInstances.push(witness);
    }
    halo2Wasm.setInstances(new Uint32Array(userInstances), 0);
    halo2Wasm.setInstances(new Uint32Array(dataInstances), 1);
    return { numUserInstances };
};
function AxiomCircuitRunner(halo2Wasm, halo2LibWasm, config, capacity, provider) {
    globalThis.axiom = {
        dataQuery: [],
        halo2lib: halo2LibWasm,
        halo2wasm: halo2Wasm,
        provider: new ethers_1.JsonRpcProvider(provider),
        results: {}
    };
    (0, halo2_lib_js_1.setCircuit)(halo2Wasm, halo2LibWasm);
    config = { ...config };
    const clear = () => {
        halo2Wasm.clear();
        halo2LibWasm.config();
        globalThis.axiom.dataQuery = [];
    };
    async function runFromString(code, inputs, inputSchema, { results, firstPass }) {
        clear();
        if (firstPass == undefined)
            firstPass = true;
        globalThis.axiom.results = results;
        const halo2Lib = await Promise.resolve().then(() => __importStar(require("@axiom-crypto/halo2-lib-js/halo2lib/functions")));
        const halo2LibFns = Object.keys(halo2Lib).filter(key => !(typeof key === 'string' && (key.charAt(0) === '_' || key === "makePublic")));
        const axiomData = await Promise.resolve().then(() => __importStar(require("./subquery")));
        const axiomDataFns = Object.keys(axiomData).filter(key => !(typeof key === 'string' && key.charAt(0) === '_'));
        let functionInputs = (0, utils_2.getInputFunctionSignature)(inputs);
        let parsedInputs = parseDataInputs(inputs);
        let fn = eval(`let {${halo2LibFns.join(", ")}} = halo2Lib; let {${axiomDataFns.join(", ")}} = axiomData; (async function(inputs) { ${code} })`);
        await fn(parsedInputs);
        const { numUserInstances } = padInstances(capacity);
        halo2Wasm.assignInstances();
        let newConfig = config;
        if (firstPass) {
            (0, halo2_lib_js_1.autoConfigCircuit)(config);
            const { config: _newConfig } = await runFromString(code, inputs, inputSchema, { results, firstPass: false });
            newConfig = _newConfig;
        }
        return {
            config: newConfig,
            numUserInstances,
            results: globalThis.axiom.results,
            dataQuery: globalThis.axiom.dataQuery
        };
    }
    async function run(f, inputs, inputSchema, results) {
        clear();
        globalThis.axiom.results = results ?? {};
        let stringifiedInputs = JSON.stringify(inputs);
        let parsedInputs = parseDataInputs(stringifiedInputs, inputSchema);
        await f(parsedInputs);
        const { numUserInstances } = padInstances(capacity);
        halo2Wasm.assignInstances();
        return {
            numUserInstances,
            results: globalThis.axiom.results,
            dataQuery: globalThis.axiom.dataQuery
        };
    }
    async function compile(f, inputs, inputSchema, results) {
        (0, halo2_lib_js_1.setCircuit)(halo2Wasm, halo2LibWasm, true);
        const res = await run(f, inputs, inputSchema, results);
        (0, halo2_lib_js_1.autoConfigCircuit)(config);
        return {
            config,
            ...res
        };
    }
    return Object.freeze({
        runFromString,
        run,
        compile
    });
}
exports.AxiomCircuitRunner = AxiomCircuitRunner;
//# sourceMappingURL=circuitRunner.js.map